import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import { push } from 'react-router-redux'
import { I18n } from 'react-redux-i18n'
import _ from 'lodash'

import api from 'core/api'
import { getAbilities } from 'modules/infos/abilities'
import { setupSessionProlongation } from 'modules/users/sessions/prolong'

export const signUpThunk = createActionThunk(
  'SIGN_UP',
  api('/users/registrations', { method: 'POST' })
)

export const signUp = props => dispatch =>
  dispatch(signUpThunk(props))
    .then(({ json: { confirmed_at } }) => {
      const url = confirmed_at ? '/' : '/users/sign_in'
      const message = confirmed_at
        ? I18n.t('devise.registrations.signed_up')
        : I18n.t('devise.registrations.signed_up_but_unconfirmed')
      dispatch(toastr.add({ type: 'success', message }))
      dispatch(push(url))
      if (confirmed_at) {
        dispatch(getAbilities())
        dispatch(setupSessionProlongation())
      }
    })
    .catch(res => {
      if (_.has(res, 'error.error.details') && _.isString(res.error.error.details))
        dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
      if (_.has(res, 'error.error.type') && res.error.error.type === 'validation_error') {
        dispatch(toastr.add({ type: 'error', message: 'Validation error' }))
        throw res.error.error.details
      }
    })

export const resetError = createAction('SIGN_UP_RESET_ERROR')

export const addReferralCode = createAction('SIGN_UP_ADD_REFERRAL_CODE')

const initialState = {}

export default handleActions(
  {
    [signUpThunk.FAILED]: (state, { payload }) => payload,
    [signUpThunk.SUCCEEDED]: () => initialState,
    [resetError]: state => ({ ...state, error: undefined }),
    [addReferralCode]: (state, { payload }) => ({ ...state, referral_code: payload })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/sign_up.js